/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useContext } from 'react';
import Layout from '../Layout/Layout';
import { AuthContext } from '../AuthContext';
import { Redirect } from 'react-router-dom';
import DomainVerificationContent from '../Home/DomainVerificationContent';

const innerWrap = {
  maxWidth: 1144,
  padding: '0 24px',
  margin: '104px auto',
  position: 'relative',
  zIndex: 10,
  '@media(min-width: 768px)': {
    margin: '152px auto',
  },
  '@media print': { marginTop: 0, padding: 0 },
};

export default function DomainVerification() {
  const { user } = useContext(AuthContext);

  if (!user) {
    return null;
  }

  return (
    <Layout>
      <div css={innerWrap}>
        <DomainVerificationContent user={user} />
      </div>
    </Layout>
  );
}
